import { useState, useEffect } from 'react';
import PageRefinedHero from '../components/layout/PageRefinedHero';
import DepositForm from '../components/investment/DepositForm';
import AlgoDepositPanel from '../components/investment/AlgoDepositPanel';
import { formatUsd } from '../data/countries';
import apiClient from '../utils/api';

const DepositPage = ({
  isLoggedIn,
  balance,
  country,
  onBack,
  onConfirm,
  onStripeDeposit,
  testDepositsEnabled,
  stripeEnabled,
  stripePublishableKey,
  depositing,
  setPage,
  addToast,
}) => {
  const [rail, setRail] = useState("usd");
  const [tokenizationEnabled, setTokenizationEnabled] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) return;
    apiClient.getTokenizationConfig()
      .then((res) => setTokenizationEnabled(Boolean(res.data?.enabled)))
      .catch(() => setTokenizationEnabled(false));
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return (
      <div className="container coown-page-body" style={{ paddingTop: "2rem", maxWidth: "560px" }}>
        <div style={{ textAlign: "center", padding: "3rem 1.5rem", background: "var(--card)", borderRadius: "var(--radius)", border: "1px solid var(--border)" }}>
          <h2>Sign in to add funds</h2>
          <p style={{ color: "var(--text-light)", margin: "1rem 0 1.5rem" }}>Your CoOwn USD wallet is available after you log in.</p>
          <button type="button" className="btn btn-primary" onClick={() => setPage("login")}>Log in</button>
        </div>
      </div>
    );
  }

  return (
    <div className="coown-page deposit-page">
      <PageRefinedHero
        badge="Wallet"
        title="Add funds"
        subtitle={`USD wallet: ${formatUsd(balance)}. Top up with card/bank (USD) or send ALGO to your embedded Algorand wallet.`}
      />
      <div className="container coown-page-body deposit-page__body">
        <div className="deposit-page__toolbar">
          <button type="button" className="btn btn-outline btn-sm" onClick={onBack}>
            <i className="fas fa-arrow-left" aria-hidden="true"></i> Back
          </button>
        </div>
        {tokenizationEnabled ? (
          <div className="deposit-page__rail-toggle">
            <button type="button" className={`btn btn-sm ${rail === "usd" ? "btn-primary" : "btn-outline"}`} onClick={() => setRail("usd")}>
              USD (card / bank)
            </button>
            <button type="button" className={`btn btn-sm ${rail === "algo" ? "btn-primary" : "btn-outline"}`} onClick={() => setRail("algo")}>
              ALGO / USDC
            </button>
          </div>
        ) : null}
        <div className="deposit-page__card">
          {rail === "algo" && tokenizationEnabled ? (
            <AlgoDepositPanel addToast={addToast} />
          ) : (
            <DepositForm
              onConfirm={onConfirm}
              onStripeDeposit={onStripeDeposit}
              country={country}
              currentBalance={balance}
              testDepositsEnabled={testDepositsEnabled}
              stripeEnabled={stripeEnabled}
              stripePublishableKey={stripePublishableKey}
              depositing={depositing}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DepositPage;
